import { domElementWithin } from '@utils'

export default {
    props: ["do"],
    mounted () {
        const listener = e => {
            if (! e.relatedTarget || e.relatedTarget.tabIndex === -1 || domElementWithin(e.relatedTarget, this.$el)) return
            this.do()
        }
        this.$el.addEventListener("focusout", listener)
        this.$once("hook:beforeDestroy", () => {
            this.$el.removeEventListener("focusout", listener)
        })
    },
    render () {
        return this.$slots.default[0]
    }
}
